import { useState } from 'react';

import { UserLimitReachedPopup } from '@components/General/ProhibitedPopups';
import ResultPopup from '@components/General/ResultPopup';
import { usePopup } from '@contexts/popupContext';
import { Application } from '@core/Application';
import { HollowedButton, NormalButton } from '@shared/designSystem/Button';
import { HorizontalContainer, VerticalContainer } from '@shared/designSystem/Containers';
import { ModalHeader } from '@shared/designSystem/ModalHeader';
import { ToastManager } from '@shared/designSystem/messages/ToastManager';
import { Text } from '@shared/designSystem/Texts';
import designSystemStyles from '@shared/styles/designSystemStyles';
import { UsersService } from '@services/UsersService';

const ReactivarColaborador = ({ row, colaborador, onDone, orgID }) => {
    const { hidePopup, showPopup } = usePopup();
    const [loading, setLoading] = useState(false);

    const handleReactivarUsuario = async () => {
        setLoading(true);
        try {
            const usersService = new UsersService(Application.shared().coreDependencies.httpClient);
            await usersService.reactivateUser(orgID, row.id);

            hidePopup();
            ToastManager.shared().showSuccessMessage(`${colaborador} reactivado exitosamente`);
            onDone();
        } catch (error) {
            if (error.message === "USER_LIMIT_REACHED") {
                showPopup(() => <UserLimitReachedPopup />);
            } else {
                showPopup(() => <ResultPopup result={"Error al reactivar usuario"} succesful={false} />);
            }
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                width: '520px',
                maxWidth: '92vw',
                backgroundColor: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                fontFamily: designSystemStyles.fontFamily,
            }}
        >
            <VerticalContainer
                width="100%"
                backgroundColor="white"
                borderRadius="20px"
                gap={designSystemStyles.gapNone}
            >
                <div
                    style={{
                        width: '100%',
                        padding: designSystemStyles.paddingLg,
                        borderBottom: `1px solid ${designSystemStyles.colorTextInputBorder}`,
                        boxSizing: 'border-box',
                    }}
                >
                    <ModalHeader title={'Reactivar colaborador'} onClose={hidePopup} />
                </div>

                <VerticalContainer
                    width="100%"
                    padding={designSystemStyles.paddingLg}
                    gap={designSystemStyles.gapLg}
                    alignment="left"
                >
                    <Text
                        text={`¿Estás seguro de que deseas reactivar a **${(colaborador ?? '').trim()}**?`}
                        markdown={true}
                        color={designSystemStyles.colorText}
                    />

                     <HorizontalContainer justifyContent="flex-end" width="100%" gap={designSystemStyles.gapSm}>
                         <HollowedButton
                             text={'Cancelar'}
                            onClick={hidePopup}
                            disabled={loading}
                             width="140px"
                         />

                        <NormalButton
                            text={'Reactivar'}
                            onClick={handleReactivarUsuario}
                            loading={loading}
                            width="160px"
                        />
                    </HorizontalContainer>
                </VerticalContainer>
            </VerticalContainer>
        </div>
    );
};

export default ReactivarColaborador;
